import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { XmMenuItem, XmSidebarComponent } from '@optek/xm-bootstrap';
import { Subject, Subscription } from 'rxjs';
import { NavBarService } from './nav-bar.service';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss']
})
export class NavBarComponent implements OnInit, OnDestroy {
  @ViewChild(XmSidebarComponent, { static: true }) xmSidebar: XmSidebarComponent;
  showMinisidebar$ = new Subject<boolean>();
  subs: Subscription[] = [];

  constructor(
    private router: Router,
    private navBarService: NavBarService,
  ) { }

  get showMinisidebar() {
    return this.navBarService.showMinisidebar;
  }

  get sidebarMenuItems$() {
    return this.navBarService.sidebarMenuItems$;
  }

  ngOnInit(): void {
    this.subs.push(this.navBarService.onMenuItemUpdate$.subscribe(itemOldTitleParent => {
      const item: XmMenuItem = itemOldTitleParent.item; // the item data
      const title: string = itemOldTitleParent.title; // the current reference title to update
      const parentTitle: string = itemOldTitleParent.parentTitle; // the parent title within which the title to update sits.

      if (!item) {
        this.xmSidebar.deleteSidebarItemByTitle(title, parentTitle);
      } else if (!title) {
        this.xmSidebar.appendSidebarItemByTitle(item, parentTitle);
      } else {
        this.xmSidebar.updateSidebarItemByTitle(item, title, parentTitle);
      }
    }));
  }

  navigate(event: any) {
    if (!event.route) {
      return;
    }
    if (event.route.params) {
      this.router.navigate([event.route.url], {
        queryParams: event.route.params
      });
    } else {
      if (event.route.isExternal) {
        window.open(event.route.url, '_blank');
      } else {
        this.router.navigate([event.route.url]);
      }
    }
  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }
}
